import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../service";
import { HttpService } from "@shared/services";
import { CompanyController } from "app/main/administration/controllers/company";
import { CheckEmployeAccessService } from "app/Shared/check-employe-access.service";

@Injectable({
  providedIn: 'root'
})
export class GeometricLocationGuard  {
  constructor(
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _httpService: HttpService,
    private _checkEmployeAccessService: CheckEmployeAccessService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const currentUser = this._authenticationService.currentUser;

    if (currentUser.companyId) {
      try {
        const res = await (
          this._httpService.GET(CompanyController.getById(currentUser.companyId))
        ).toPromise();

        const isEnabled = res?.company?.isCheckInOutEnabled ?? false;
        this._checkEmployeAccessService.setEnableGeometricLocations(isEnabled);

        if (!isEnabled) {
          await this._router.navigate(['/auth/login']);
          return false;
        }

        return true;
      } catch (error) {
        console.error('Error fetching company details:', error);
        await this._router.navigate(['/auth/login']);
        return false;
      }
    }

    return true;
  }
}